import type { PropsWithChildren } from 'react';

import { Box, Group, Stack, Text, Title } from '@mantine/core';

import { Trans, useTranslation } from 'react-i18next';

import SearchLogo from '../../shared/assets/UI/logo/logo_without_text.svg?react';

import { VaultSearchInput } from '../../features/bidResponse/components/vaultSearch/components/VaultSearchInput';

export function VaultSearchNewPage() {
  const { t } = useTranslation('bidResponse');
  return (
    <>
      <Stack spacing="04">
        <Group noWrap spacing="02">
          <Text size="md" c="gray.9" fw={500}>
            {t('search.title')}
          </Text>
        </Group>
      </Stack>
      <Stack align="center" mt="07" spacing="07">
        <Stack spacing="03" align="center">
          <SearchLogo height={50} />
          <Title c="gray.9" order={2}>
            <Trans
              ns="bidResponse"
              i18nKey="search.subtitle"
              components={{
                highlight: <SubtitleHighlight />,
              }}
            />
          </Title>
        </Stack>
        <Box
          bg="rgba(255, 255, 255, 0.50)"
          w="100%"
          maw="878px"
          p="05"
          sx={{
            borderRadius: 24,
            border: '2px solid #FFF',
          }}
        >
          <VaultSearchInput withExample />
        </Box>
      </Stack>
    </>
  );
}

function SubtitleHighlight({ children }: PropsWithChildren) {
  return (
    <Text component="span" c="primary.7">
      {children}
    </Text>
  );
}
